import TokenHandler from './TokenHandler'

export default TokenHandler


// WEBPACK FOOTER //
// ./src/components/home/tokenHandler/index.jsx